import {BaseCachedService} from './Core/BaseCachedService';

const PERMISSION_TYPE_ROLE = 1;
const PERMISSION_TYPE_USER = 2;

class PermissionService extends BaseCachedService {
    get ModelName() { return "Permission"; }
    get PrimaryKeyProperty() { return "permissionId"; }
    get TitleProperty() { return "name"; }
    get Url() { return super.Url + "/permissions"; }

    GetPermissions(permissionType) {
        return new Promise((resolve, reject) => {
            this.Get().then((x) => {
                resolve({
                    ...x,
                    result: x.result.filter((x) => x.permissionTypeId == PERMISSION_TYPE_USER)
                });
            }).catch((x) => {
                reject(x)
            })
        });
    }

    GetPermission(permissionId) {
        return this.FindById(permissionId)
        //return this.SendRequest(BaseService.GET, permissionId);
    }
}

export const service = new PermissionService();

